import { createSlice } from '@reduxjs/toolkit'

const defaultValue = {
    show: false
}

export const errorSlice = createSlice({
    name: 'error',
    initialState: defaultValue,
    reducers: {
        showError: (state, action) => {
            return action.payload
        },
        resetError: () => {
            return defaultValue
        }
    }
})

export const { showError, resetError } = errorSlice.actions
export default errorSlice.reducer